import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import './Ranking.css';

const NIVELES = [
  { min:1000, n:'Rescatista', bg:'#d1fae5', c:'#0e5c30' },
  { min:700,  n:'Protector',  bg:'#e3f4f9', c:'#0e6e8a' },
  { min:400,  n:'Guardián',   bg:'#fdf3d0', c:'#7a4e00' },
  { min:0,    n:'Aliado',     bg:'#f3e8ff', c:'#4c1d95' },
];
const AV_BG = ['#d1fae5','#e3f4f9','#fdf3d0','#fdecea','#f3e8ff','#fef3dc'];
const AV_C  = ['#0e5c30','#0e6e8a','#7a4e00','#c0392b','#4c1d95','#7a4e00'];
const POS_C = ['#a16207','#64748b','#92400e'];

export default function Ranking() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    api.get('/ranking?limit=20')
      .then(r => setUsuarios(r.data))
      .finally(() => setLoading(false));
  }, []);

  const nivel = (pts) => NIVELES.find(n => pts >= n.min) || NIVELES[NIVELES.length-1];
  const shown = expanded ? usuarios : usuarios.slice(0,10);

  return (
    <div className="page-wrap fade-up">
      <div className="sec-title">🏆 Ranking de la comunidad <small>Actualizado en tiempo real</small></div>

      {loading ? <div className="spinner"/> : (
        <div className="r-card card card-np">
          <div className="r-head">
            <span className="font-fraunces font-black text-[15px] text-vd">Top colaboradores</span>
            <span className="text-xs font-bold text-txs">Puntos por acciones reales</span>
          </div>

          {shown.map((u, i) => {
            const pos = i+1;
            const nv  = nivel(u.puntos);
            const ini = (((u.nombre || u.email || '?')[0]) + (u.apellido?.[0]||'')).toUpperCase();
            return (
              <div key={u._id} className="r-item">
                <span className="r-pos" style={{color: POS_C[i]||'var(--txs)'}}>{pos}</span>
                <div className="avatar r-av w-[38px] h-[38px] text-xs" style={{background:AV_BG[i%6],color:AV_C[i%6]}}>
                  {ini}
                </div>
                <div className="r-info">
                  <p>{u.nombre} {u.apellido}</p>
                  <small className="capitalize">{u.rol} · {u.acciones?.length||0} acciones</small>
                </div>
                <span className="badge" style={{background:nv.bg,color:nv.c}}>{nv.n}</span>
                <span className="r-pts" style={{color:POS_C[i]||'var(--txm)'}}>{Number(u.puntos||0).toLocaleString()}</span>
              </div>
            );
          })}

          {usuarios.length > 10 && (
            <button className="exp-btn" onClick={() => setExpanded(e => !e)}>
              {expanded ? 'Ocultar ▲' : `Ver posiciones 11–${Math.min(20,usuarios.length)} ▼`}
            </button>
          )}
          {usuarios.length === 0 && (
            <p className="p-6 text-center text-txs font-bold">Aún no hay usuarios en el ranking.</p>
          )}
        </div>
      )}

      <div className="pts-info">
        Sistema de puntos: <strong>Rescate urgente</strong> +80 · <strong>Voluntariado</strong> +50 · <strong>Adopción</strong> +100 · <strong>Donación</strong> +30 · <strong>Reporte</strong> +20
      </div>
    </div>
  );
}
